import config from "../config.json";
import { apiClient } from "./apiClient";

const Login = async (loginReq) => {
  let url = `${config.API_URL}/auths/authorize`;
  let headers = {
    "Content-Type": "application/json",
  };

  try {
    return await apiClient.post(url, JSON.stringify(loginReq), {
      headers,
      timeout: config.API_CONNECTION_TIMEOUT,
    });
  } catch (error) {
    // throw error;
  }
};

const RefreshToken = async (refreshTokenReq) => {
  let url = `${config.API_URL}/auths/refresh-token`;
  let headers = {
    "Content-Type": "application/json",
  };

  try {
    return await apiClient.post(url, JSON.stringify(refreshTokenReq), {
      headers,
      timeout: config.API_CONNECTION_TIMEOUT,
    });
  } catch (error) {
    // throw error;
  }
};

const LoginMessenger = async (data) => {
  let url = `${config.API_URL}/auths/login`;
  let headers = {
      "Content-Type": "application/json",
  };

  try {
      return await apiClient.post(url, JSON.stringify(data), {
          headers,
          timeout: config.API_CONNECTION_TIMEOUT,
      });
  } catch (error) {
      console.error('LoginMessenger error:', error); // ← เพิ่ม
      throw error; // ← เปลี่ยนจาก comment เป็น throw
  }
};

const authenService = {
  Login,
  LoginMessenger,
  RefreshToken,
};

export default authenService;
